// extracted by mini-css-extract-plugin
export default {"root":"GeneralDetails_root__1Rjb0","tnc-label":"GeneralDetails_tnc-label__gSpKR","product-wrapper":"GeneralDetails_product-wrapper__A00JH"};